<div class="admin-content-header d-flex">
  <div class="title">
    <h1 class="header-title">
      إدارة المستخدمين
    </h1>
  </div>
  <div ngbDropdown class="d-flex ml-auto">
    <div>
      <button [qcId]="'export-btn'" type="button" class="d-flex btn DS btn-outline-green ml-1 mr-1" id="dropdownBasic1"
        *ngIf="checkPermission('Pages.User.Default')" ngbDropdownToggle>
        <i class="fa-solid fa-file-arrow-down"></i>
        <span> إصدار تقرير </span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="reports text-light"
        *ngIf="checkPermission('Pages.User.Default')">
        <button [qcId]="'export-excel'" (click)="exportAsExcel()" ngbDropdownItem>
          <i class="fa-regular fa-file-spreadsheet"></i>
          <span> إصدار بصيغة Excel</span>
        </button>
        <button [qcId]="'export-pdf'" (click)="exportAsPdf()" ngbDropdownItem>
          <i class="fa-solid fa-file-pdf"></i>
          <span>إصدار بصيغة PDF</span>
        </button>
      </div>
    </div>
    <div>
      <button [qcId]="'create-btn'" type="button" class="d-flex btn Dsbtn-green ml-1 mr-1" id="create-btn"
        *ngIf="checkPermission('Pages.User.Create')" (click)="create()">
        <i class="fa-solid fa-plus"></i>
        <span> إضافة مستخدم جديد </span>
      </button>
    </div>
  </div>
</div>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a>
        <i class="d-inline-block fa-regular fa-house-blank"></i>
        <span> الرئيسية</span>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      إدارة المستخدمين
    </li>
  </ol>
</nav>

<div class="table-content">
  <div class="table-content-header">
    <div
      class="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-sm-center align-items-start pl-4 pr-4 pt-4 pb-4">
      <div>
        <div class="count">
          <span [qcId]="'totalcount-span'" class="count-number text-black">{{gridView.totalCount}}</span>
          <span class="count-title">مستخدم</span>
        </div>
      </div>
      <div class="ml-auto">
        <div class="input-group search-group">
          <input [qcId]="'search-btn'" type="text" #inputRef class="form-control" (input)="refresh(1)"
            [(ngModel)]="this.searchModel.filter" placeholder="بحث" />
        </div>
      </div>
      <div>
        <div ngbDropdown #dropdown="ngbDropdown" class="filter filter-critria">
          <button type="button" class="btn btn-outline-secondary search" id="dropdownConfig" ngbDropdownToggle>
            <i class="fa-solid fa-bars-filter"></i>
            <span>تصفية</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownConfig">
            <app-user-filter #filter [searchModel]="this.searchModel" (model)="filterData($event)">
            </app-user-filter>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">{{"CreateOrUpdateUser.UserName" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.JobID" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.Email" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.Mobile" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.UserType" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.Permissions" | translate}}</th>
          <th scope="col">{{"CreateOrUpdateUser.ActiveStatus" | translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="gridView?.items?.length === 0">
          <td class="text-center" colspan="8">
            <span><b>{{"Global.NoResult" | translate}}</b></span>
          </td>
        </tr>
        <tr *ngFor="let item of gridView?.items">
          <td>{{item.name}} {{item.surname}}</td>
          <td>{{item.jobID}}</td>
          <td>{{item.email}}</td>
          <td>{{item.mobile}}</td>
          <td>{{item.userType}}</td>
          <td>
            {{item.permissions.join(" - ")}}
          </td>
          <td>
            <span class="badge" [ngClass]="item.activeStatus">
              {{ ("Global." + item.activeStatus) | translate}}
            </span>
          </td>
          <td>
            <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
              <button type="button" class="btn btn-default me-2" id="dropdownManual" ngbDropdownToggle>
                <i class="fa-solid fa-ellipsis"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button ngbDropdownItem (click)="update(item.id)" *ngIf="checkPermission('Pages.User.Update')">
                  <i class="fa-regular fa-eye"></i>
                  <span>تعديل</span>
                </button>
                <div *ngIf="checkPermission('Pages.User.Activation')">
                  <button ngbDropdownItem *ngIf="item.activeStatus === 'InActive'" (click)="activate(item.id)">
                    <i class="fa-solid fa-check"></i>
                    <span>تفعيل</span>
                  </button>
                  <button ngbDropdownItem *ngIf="item.activeStatus === 'Active'" (click)="deactivate(item.id)">
                    <i class="fa-solid fa-xmark-large"></i>
                    <span>تعطيل</span>
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-content-footer">
      <div class="d-flex justify-content-between p-2">
        <div class="show-results d-flex align-items-center">
          <span>اظهر </span>
          <select class="form-select form-control" [(ngModel)]="pageSize" (ngModelChange)="onPageSizechange()">
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <span>نتائج</span>
        </div>
        <ngb-pagination [collectionSize]="gridView?.totalCount" [(page)]="gridView.pageNumber"
          [pageSize]="gridView.pageSize" [maxSize]="10" (pageChange)="refresh($event)" [rotate]="true"
          [boundaryLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>